import { render, staticRenderFns } from "./index_ymkj.vue?vue&type=template&id=ebd82fe8&scoped=true&"
import script from "./index_ymkj.vue?vue&type=script&lang=js&"
export * from "./index_ymkj.vue?vue&type=script&lang=js&"
import style0 from "./index_ymkj.vue?vue&type=style&index=0&id=ebd82fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd82fe8",
  null
  
)

export default component.exports